import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyPages = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 600 600",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M234.73,12.75l213.25-.36c32.06,4,56.86,29.64,59.12,62l-.04,312.59c-2.71,32.01-27.5,58.26-59.74,61.38l-212.56-.04c-35.22-5.3-57.51-30.47-58.19-65.98-2.01-104.62,1.34-209.44.06-314.07,4.76-29.44,28.29-52.4,58.1-55.51ZM236.52,39.85c-18.75,3.17-31.85,17.99-33.4,36.93.72,104.81-1.5,209.9,1.12,314.55,5.69,19.56,19.96,29.15,39.9,30.43,63.33,4.07,130.84-3.06,194.6.04,21.54-.46,39.37-15.13,41.02-37.12V75.95c-1.48-18.98-16.11-33.8-34.81-36.3l-208.43.19Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M130.71,548.07c6.28,6.69,15.35,10.57,24.35,11.99l207.75-.09c19.01-3.03,32.51-17.8,34.08-37.03.65-7.95-1.68-23.62,1.27-29.99,5.34-11.54,24.08-8.92,25.35,4.18,4.12,42.52-8.13,78.91-53.15,89.15-71.81,2.64-144.1.41-216.08,1.13-32.97-2.64-59.12-29.03-61.38-62.08V213.48c1.11-16.05,9.92-36.01,22.69-46.08,7.35-5.8,18.64-5.16,22.26,4.32,4.65,12.16-4.79,15.03-10.39,23.18-4.28,6.24-6.65,12.52-7.21,20.14v308.72c.67,8.54,4.62,18.08,10.46,24.31Z"
	})]
});
export default SvgCopyPages;
